import { useContext } from 'react';
import { FilterContext, IFilterContext } from './FilterContext';

const useFilters = (): IFilterContext => useContext(FilterContext);

export default useFilters;
